// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useContext} from 'react';
import cn from 'classnames';
import styles from './block.module.less';
import {Settings_context} from '../../settings_ctx';

interface i_block_props {
    img: JSX.Element;
    text: JSX.Element;
    text_position: 'left'|'right';
    cls?: string;
    section_cls?: string;
    size?: 'lg';
}
export const Block = ({img, text, text_position, cls, size, section_cls}:
    i_block_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={cn(theme.container, cls)}>
        <div></div>
        <section className={cn(styles.block, text_position=='right'
        && styles.reverse, size && styles[size], section_cls)}>
        {text_position=='left' ? <Fragment>
          <div className={styles.text_left}>
            <div className={styles.text}>{text}</div>
          </div>
          <div>{img}</div>
        </Fragment> : <Fragment>
          <div>{img}</div>
          <div className={styles.text_right}>
            <div className={styles.text}>{text}</div>
          </div>
        </Fragment>}
      </section>
    </div>;
};
export const block_styles = styles;
